import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DOMPurify from "dompurify";
import { Select } from "../../Common/Forms";
import moment from "moment";
import TimePicker from "rc-time-picker";
import Notify from "../../Common/Notify";
import Loading from "../../Pages/Signup/Loading";
import RichTextInput from "../RichText/RichTextInput";
import {
  createScheduleMessage,
  retrieveScheduleMessage,
  deleteScheduledMessage,
} from "../../../actions/ThreadAction";
import "./ScheduledModal.css";

const $ = window.$;

function ScheduledModal({
  isOpen = false,
  circleId,
  modalClose = () => {},
}) {
  const dispatch = useDispatch();

  const { richText } = useSelector(mySelector, shallowEqual);

  const modalId = "#scheduled_modal";
  var today = new Date();
  const [isLoading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isMessageEmpty, setIsMessageEmpty] = useState(true);
  const [start_time, setStartTime] = useState(() => moment().startOf('hour'));
  const [formattedTimezone, setFormattedTimezone] = useState("");
  const [editTextMessage, setEditTextMessage] = useState("");
  const [id, setId] = useState(null);
  const [week, setWeek] = useState(1);
  const [step, setStep] = useState(1);

  const daysOfWeek = [
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
    { value: 7, label: "Sunday" },
  ];

  useEffect(() => {
    // componentDidMount();
    getScheduledMessage()
  }, [isOpen]);

  useEffect(() => {
    const getFormattedTimezone = () => {
      const date = new Date();

      const offsetMinutes = date.getTimezoneOffset();
      const sign = offsetMinutes > 0 ? '-' : '+';
      const absOffset = Math.abs(offsetMinutes);
      const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
      const minutes = String(absOffset % 60).padStart(2, '0');
      const offsetStr = `(UTC${sign}${hours}:${minutes})`;

      const timeZoneName = Intl.DateTimeFormat('en-US', {
        timeZoneName: 'long'
      }).format(date).split(', ')[1];

      return `${offsetStr} ${timeZoneName}`;
    };

    setFormattedTimezone(getFormattedTimezone());
  }, []);

  useEffect(() => {
    const cleanHTML = DOMPurify.sanitize(richText);
    const tempDiv = document.createElement("span");
    tempDiv.innerHTML = cleanHTML;
    const cleanText = tempDiv.innerText;
    const normalizedText = cleanText.replace(/\s+/g, "").trim();

    setIsMessageEmpty(normalizedText === "");
  }, [richText]);

  function getScheduledMessage() {
    setLoading(true);
    dispatch(retrieveScheduleMessage(circleId))
      .then((res) => {
        const { schedule } = res;
        if (schedule) {
          setIsMessageEmpty(false);
          setEditTextMessage(schedule.message);
          setStartTime(moment(schedule.message_at, "HH:mm"));
          setWeek(schedule.message_every);
          setId(schedule.objectId);
        }
      setLoading(false);
    });
  }

  function handleSubmit() {
    setLoading(true);
      
    let message = {
      message_every: parseInt(week, 10),
      message_at: start_time.format("HH:mm"),
      message: richText,
      circleId: circleId,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }

    dispatch(createScheduleMessage(message))
      .then((res) => {
        const { schedule } = res;

        if (id) {
          Notify.success("Schedule message successfully updated");
        } else {
          Notify.success("Schedule message successfully set");
        }
        setId(schedule.objectId);
        setLoading(false);
    });
  }

  function deleteScheduleMessage() {
    setOpenConfirm(false);
    setLoading(true);
    dispatch(deleteScheduledMessage(id))
      .then((res) => {
        Notify.success("Removed schedule message");
        setLoading(false);
        modalClose();
    });
  }

  function componentDidMount() {
    if (isOpen) {
      localStorage.setItem("someModalIsOpen", "true");
      $(modalId).modal({
        backdrop: "static",
        keyboard: false,
      });
      $(modalId).modal("show");
    } else {
      $(modalId).modal("hide");
    }
  }

  return (
    <div id="scheduled_modal" className="schedule-message-modal-container">
      <div className="schedule-message-container">
        <div className="save-changes-flex" style={{ marginLeft: 5 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {/* <i className="fas fa-paper-plane hc-primary-text"></i> */}
            <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
              Schedule Message
            </h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => modalClose()}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div className="mb-15">
          <div
            className="Form-Container form-bypass"
            style={{ margin: "20px 0", maxWidth: "100%" }}
          >
            <div
              style={{
                height: "250px",
                marginBottom: "10px",
                display: step === 1 ? "block" : "none"
              }}
            >
              <label htmlFor="week" className="label-cls">
                Day of Week
              </label>
              <div className="form-group">
                <div className="">
                  <Select 
                    className="form-control"
                    style={{ color: "##495057 !important" }} 
                    value={week}
                    onChange={(e) => setWeek(e.target.value)}
                    disabled={isLoading}
                  >
                    {daysOfWeek.map((day) => (
                      <option key={day.value} value={day.value}>
                        {day.label}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <label htmlFor="time" className="label-cls">
                Time
              </label>
              <div className="form-group">
                <div className="card no-shadow">
                  <TimePicker 
                    showSecond={false}
                    use12Hours={true}
                    onChange={time => setStartTime(time)}
                    value={start_time}
                    allowEmpty={false}
                    minuteStep={15}
                    disabled={isLoading}
                  />
                  <i className="fas fa-clock hc-primary-text"></i>
                </div>
              </div>
              <label className="label-cls" style={{ fontSize: "12px" }}>
                {"Time zone: " + formattedTimezone}
              </label>
            </div>
            <div 
              style={{
                height: "250px",
                border: "1px solid #d1d3e2",
                borderRadius: "0.35rem",
                padding: "5px",
                marginBottom: "10px",
                display: step !== 1 ? "block" : "none"
              }}>
              <RichTextInput
                onFocus={() => {}}
                isTyping={() => {}}
                editTextMessage={editTextMessage}
                placeholder=""
              />
            </div>        
            <div 
              className="p-1 mt-auto"
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <button
                type="button"
                className="btn btn-hubchart btn-hubchart-close btn-sm"
                style={{ height: "30px" }}
                onClick={() => setStep(1)}
              >
                <i className="fas fa-chevron-left"></i>
              </button>
              <span className="px-2 py-1">Step {step} of 2</span>
              <button
                type="button"
                className="btn btn-hubchart btn-hubchart-close btn-sm"
                style={{ height: "30px" }}
                onClick={() => setStep(2)}
              >
                <i className="fas fa-chevron-right"></i>
              </button>
              
              {isLoading ? (
                <div
                  className="form-group ml-auto"
                  style={{
                    textAlign: "right",
                    position: "relative",
                    height: "40px"
                  }}
                >
                  <Loading />
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: "auto",
                  }}
                >
                  {!isLoading && id && (
                    <button
                      type="button"
                      className="ml-auto btn btn-danger btn-sm"
                      style={{ marginRight: "10px", height: "30p" }}
                      onClick={() => setOpenConfirm(true)}
                    >
                      Remove
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-hubchart btn-hubchart-primary"
                    style={{ height: "30px" }}
                    onClick={() => handleSubmit()}
                    disabled={isLoading || step === 1 || isMessageEmpty}
                  >
                  {!id ? 
                    (
                      "Set schedule"
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {openConfirm && (
        <Confirmation
          deleteScheduleMessage={() => deleteScheduleMessage()}
          onClose={setOpenConfirm}
        />
      )}
    </div>
  );
}

const Confirmation = ({ deleteScheduleMessage, onClose = () => {} }) => {
  return (
    <div className="assignment-notify-container">
      <div className="attention-notify-box" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6>Remove current scheduled message ?</h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className="btn btn-danger"
              onClick={() => deleteScheduleMessage()}
            >
              Remove
            </button>
            <button 
              type="button btn-sm" 
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mySelector = (state) => ({
  richText: state.thread.richText,
});

export default ScheduledModal;
